module.exports = __webpack_public_path__ + "img/ama-website.336a7b7d.png";